module.exports = __webpack_public_path__ + "static/media/delete-blue.2cdc705c.svg";